import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { SignatureDishes } from "@/components/landing/SignatureDishes";
import { MenuSection } from "@/components/landing/MenuSection";
import { Services } from "@/components/landing/Services";
import { Bento } from "@/components/landing/Bento";
import { ChefAbout } from "@/components/landing/ChefAbout";
import { Testimonials } from "@/components/landing/Testimonials";
import { Gallery } from "@/components/landing/Gallery";
import { ContactCTA } from "@/components/landing/ContactCTA";
import { Footer } from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const anchors = document.querySelectorAll('a[href^="#"]');
    const onClick = (e) => {
      const id = e.currentTarget.getAttribute("href");
      if (id && id.length > 1) {
        e.preventDefault();
        lenis.scrollTo(id, { offset: -72 });
      }
    };
    anchors.forEach((a) => a.addEventListener("click", onClick));

    return () => {
      anchors.forEach((a) => a.removeEventListener("click", onClick));
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div id="top" className="grain bg-bone font-sans text-noir antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <SignatureDishes />
        <MenuSection />
        <Services />
        <Bento />
        <ChefAbout />
        <Testimonials />
        <Gallery />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
